import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

const screen = SCREEN.FINANCIAL_ANALYSIS

export const getNonLifeInsOperationalEfficiencyThunk = createAsyncThunk(
  'financialAnalysis/NonLifeIns/getNonLifeInsOperationalEfficiency',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getOperationalEfficiency(
      data,
    )
    if (response.success) {
      const getValues = () => mapAllVNDValue(response.data)
      dispatch(calculateDefaultUnit({ screen, getValues }))
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonLifeInsOperationalEfficiency = createAsyncThunk(
  'financialAnalysis/NonLifeIns/downloadNonLifeInsOperationalEfficiency',
  async (data) => {
    const response =
      await FinancialAnalysisService.downloadOperationalEfficiency(data)
    handleExport(response.data, response.filename)
  },
)
